import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a50aece"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Annual Leave\n          ")
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n            What is the employees current annual leave situation? *\n          ", -1));
const _hoisted_5 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_6 = { class: "mt-4 space-y-4" };
const _hoisted_7 = { class: "flex items-start" };
const _hoisted_8 = { class: "h-5 flex items-center" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "leave_situation",
        class: "font-medium text-gray-700"
    }, "The employee has unused annual leave which needs to be paid\n                  (Credit)")
], -1));
const _hoisted_11 = { class: "flex items-start" };
const _hoisted_12 = { class: "h-5 flex items-center" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "leave_situation",
        class: "font-medium text-gray-700"
    }, "The employee has used more than their annual leave\n                    entitlement, their pay will need to be deducted\n                    (Debit)")
], -1));
const _hoisted_15 = { class: "flex items-start" };
const _hoisted_16 = { class: "h-5 flex items-center" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "leave_situation",
        class: "font-medium text-gray-700"
    }, "The employees annual leave is balanced")
], -1));
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          If you have any queries in relation to annual leave please contact\n          your local HR manager.\n        ", -1));
const _hoisted_20 = { key: 0 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Is this in days or hours? *\n            ", -1));
const _hoisted_22 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_23 = { class: "mt-4 space-y-4" };
const _hoisted_24 = { class: "flex items-start" };
const _hoisted_25 = { class: "h-5 flex items-center" };
const _hoisted_26 = ["disabled"];
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "days_hours",
        class: "font-medium text-gray-700"
    }, "Days")
], -1));
const _hoisted_28 = { class: "flex items-start" };
const _hoisted_29 = { class: "h-5 flex items-center" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "days_hours",
        class: "font-medium text-gray-700"
    }, "Hours")
], -1));
const _hoisted_32 = { class: "col-span-6 mt-4" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "be_paid",
    class: "block text-sm font-medium text-gray-700"
}, "How much annual leave should be paid/deducted?", -1));
const _hoisted_34 = ["disabled"];
const _hoisted_35 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n            The amount entered must be rounded up to the nearest 0.5 days, for\n            example 7.23 should show as 7.5 and 7.66 to 8.0\n          ", -1));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n            Please note payment in lieu of holidays is subject to tax and\n            national insurance.\n          ", -1));
const _hoisted_38 = { class: "col-span-6" };
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Comments on annual leave:", -1));
const _hoisted_40 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_41 = ["disabled"];
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          Please note any comments related to the employees annual leave which\n          you would like to share with the SSC Leavers Team.\n        ", -1));
const _hoisted_43 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_44 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("fieldset", null, [
                    _hoisted_4,
                    _createTextVNode(),
                    (_ctx.v$.formData.leave_situation.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "\n            * " + _toDisplayString(_ctx.v$.formData.leave_situation.$errors[0].$message), 1))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "radio-button-leave_situation-credit",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formData.leave_situation) = $event)),
                                    value: "The employee has unused annual leave which needs to be paid (Credit)",
                                    name: "leave_situation",
                                    type: "radio",
                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.leave_situation.$touch()))
                                }, null, 42, _hoisted_9), [
                                    [_vModelRadio, _ctx.formData.leave_situation]
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_10
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "radio-button-leave_situation-debit",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.leave_situation) = $event)),
                                        value: "The employee has used more than their annual leave entitlement, their pay will need to be deducted (Debit)",
                                        name: "leave_situation",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.leave_situation.$touch()))
                                    }, null, 42, _hoisted_13), [
                                        [_vModelRadio, _ctx.formData.leave_situation]
                                    ])
                                ]),
                                _createTextVNode(),
                                _hoisted_14
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "radio-button-leave_situation-balanced",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.leave_situation) = $event)),
                                        value: "The employees annual leave is balanced",
                                        name: "leave_situation",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.leave_situation.$touch()))
                                    }, null, 42, _hoisted_17), [
                                        [_vModelRadio, _ctx.formData.leave_situation]
                                    ])
                                ]),
                                _createTextVNode(),
                                _hoisted_18
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _hoisted_19,
                _createTextVNode(),
                (_ctx.formData.leave_situation !==
                    'The employees annual leave is balanced')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_21,
                            _createTextVNode(),
                            (_ctx.v$.formData.days_hours.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "\n              * " + _toDisplayString(_ctx.v$.formData.days_hours.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "radio-button-days",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.days_hours) = $event)),
                                            value: "Days",
                                            name: "days_hours",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                }]),
                                            disabled: _ctx.disableForm,
                                            onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.days_hours.$touch()))
                                        }, null, 42, _hoisted_26), [
                                            [_vModelRadio, _ctx.formData.days_hours]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_27
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "radio-button-hours",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.formData.days_hours) = $event)),
                                                value: "Hours",
                                                name: "days_hours",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                    }]),
                                                disabled: _ctx.disableForm,
                                                onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.days_hours.$touch()))
                                            }, null, 42, _hoisted_30), [
                                                [_vModelRadio, _ctx.formData.days_hours]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_31
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "be_paid-input",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.formData.be_paid) = $event)),
                                disabled: _ctx.disableForm,
                                type: "number",
                                min: "0",
                                name: "be_paid",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                        'error-border': _ctx.v$.formData.be_paid.$error,
                                        'border-red-500': _ctx.v$.formData.be_paid.$error,
                                    }]),
                                onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.be_paid.$touch()))
                            }, null, 42, _hoisted_34), [
                                [_vModelText, _ctx.formData.be_paid]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.be_paid.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "\n              * " + _toDisplayString(_ctx.v$.formData.be_paid.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _hoisted_36,
                        _createTextVNode(),
                        _hoisted_37
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("textarea", {
                            id: "comments",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.formData.leave_comments) = $event)),
                            name: "leave_comments",
                            rows: "3",
                            class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm
                        }, null, 10, _hoisted_41), [
                            [_vModelText, _ctx.formData.leave_comments]
                        ])
                    ])
                ]),
                _createTextVNode(),
                _hoisted_42
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.formData.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_44)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
